/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExpressOutboundOrderVo } from './ExpressOutboundOrderVo';
import {
    ExpressOutboundOrderVoFromJSON,
    ExpressOutboundOrderVoFromJSONTyped,
    ExpressOutboundOrderVoToJSON,
    ExpressOutboundOrderVoToJSONTyped,
} from './ExpressOutboundOrderVo';

/**
 * 
 * @export
 * @interface ExpressOutboundVo
 */
export interface ExpressOutboundVo {
    /**
     * 中国入库/出库管理-结算完成数量
     * @type {number}
     * @memberof ExpressOutboundVo
     */
    cnWmsPaidCount?: number;
    /**
     * 中国入库/出库管理-出库待定数量
     * @type {number}
     * @memberof ExpressOutboundVo
     */
    cnWmsWaitOutboundCount?: number;
    /**
     * 中国入库/出库管理-海运数量
     * @type {number}
     * @memberof ExpressOutboundVo
     */
    seaCount?: number;
    /**
     * 中国入库/出库管理-空运数量
     * @type {number}
     * @memberof ExpressOutboundVo
     */
    airCount?: number;
    /**
     * 总箱数
     * @type {number}
     * @memberof ExpressOutboundVo
     */
    boxTotalCount?: number;
    /**
     * 总重量
     * @type {number}
     * @memberof ExpressOutboundVo
     */
    totalWeight?: number;
    /**
     * 总体积
     * @type {number}
     * @memberof ExpressOutboundVo
     */
    totalCBM?: number;
    /**
     * 出库订单列表
     * @type {Array<ExpressOutboundOrderVo>}
     * @memberof ExpressOutboundVo
     */
    expressOutboundOrderVOList?: Array<ExpressOutboundOrderVo>;
}

/**
 * Check if a given object implements the ExpressOutboundVo interface.
 */
export function instanceOfExpressOutboundVo(value: object): value is ExpressOutboundVo {
    return true;
}

export function ExpressOutboundVoFromJSON(json: any): ExpressOutboundVo {
    return ExpressOutboundVoFromJSONTyped(json, false);
}

export function ExpressOutboundVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpressOutboundVo {
    if (json == null) {
        return json;
    }
    return {
        
        'cnWmsPaidCount': json['cnWmsPaidCount'] == null ? undefined : json['cnWmsPaidCount'],
        'cnWmsWaitOutboundCount': json['cnWmsWaitOutboundCount'] == null ? undefined : json['cnWmsWaitOutboundCount'],
        'seaCount': json['seaCount'] == null ? undefined : json['seaCount'],
        'airCount': json['airCount'] == null ? undefined : json['airCount'],
        'boxTotalCount': json['boxTotalCount'] == null ? undefined : json['boxTotalCount'],
        'totalWeight': json['totalWeight'] == null ? undefined : json['totalWeight'],
        'totalCBM': json['totalCBM'] == null ? undefined : json['totalCBM'],
        'expressOutboundOrderVOList': json['expressOutboundOrderVOList'] == null ? undefined : ((json['expressOutboundOrderVOList'] as Array<any>).map(ExpressOutboundOrderVoFromJSON)),
    };
}

export function ExpressOutboundVoToJSON(json: any): ExpressOutboundVo {
    return ExpressOutboundVoToJSONTyped(json, false);
}

export function ExpressOutboundVoToJSONTyped(value?: ExpressOutboundVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cnWmsPaidCount': value['cnWmsPaidCount'],
        'cnWmsWaitOutboundCount': value['cnWmsWaitOutboundCount'],
        'seaCount': value['seaCount'],
        'airCount': value['airCount'],
        'boxTotalCount': value['boxTotalCount'],
        'totalWeight': value['totalWeight'],
        'totalCBM': value['totalCBM'],
        'expressOutboundOrderVOList': value['expressOutboundOrderVOList'] == null ? undefined : ((value['expressOutboundOrderVOList'] as Array<any>).map(ExpressOutboundOrderVoToJSON)),
    };
}

